module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.marketplaces,
      "multiple": "",
      "placeholder": "Selecteer een marktplaats",
      "selected-label": "✔",
      "select-label": "",
      "deselect-label": "✔"
    },
    on: {
      "input": _vm.reload
    },
    model: {
      value: (_vm.selectedMarketplaces),
      callback: function($$v) {
        _vm.selectedMarketplaces = $$v
      },
      expression: "selectedMarketplaces"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateFrom),
      expression: "dateFrom"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Periode van"
    },
    domProps: {
      "value": (_vm.dateFrom)
    },
    on: {
      "change": _vm.reload,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateFrom = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateTo),
      expression: "dateTo"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "40px"
    },
    attrs: {
      "type": "date",
      "placeholder": "Periode van"
    },
    domProps: {
      "value": (_vm.dateTo)
    },
    on: {
      "change": _vm.reload,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateTo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeVat),
      expression: "includeVat"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeVat) ? _vm._i(_vm.includeVat, null) > -1 : (_vm.includeVat)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.includeVat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeVat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeVat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeVat = $$c
        }
      }, _vm.reload]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Incl btw\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeShipping),
      expression: "includeShipping"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeShipping) ? _vm._i(_vm.includeShipping, null) > -1 : (_vm.includeShipping)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.includeShipping,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeShipping = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeShipping = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeShipping = $$c
        }
      }, _vm.reload]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Incl verzendkosten\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllMarketplaces),
      expression: "selectAllMarketplaces"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllMarketplaces) ? _vm._i(_vm.selectAllMarketplaces, null) > -1 : (_vm.selectAllMarketplaces)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAllMarketplaces,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllMarketplaces = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllMarketplaces = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllMarketplaces = $$c
        }
      }, _vm.reload]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Selecteer alle kanalen\n              ")])])])]), _vm._v(" "), (!_vm.result) ? _c('div', {
    staticClass: "text-center p-50"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-5x fa-spinner"
  })]) : _c('div', [_c('div', {
    staticClass: "chart"
  }, [_c('line-chart', {
    attrs: {
      "result": _vm.result
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container revenue-numbers"
  }, [_c('div', {
    staticClass: "row gx-10"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "p-3 border bg-light"
  }, [_c('h5', [_vm._v("Omzet")]), _vm._v(" "), _c('h3', [_vm._v("\n              €\n              "), _c('span', [_vm._v("\n                " + _vm._s(_vm.result.total_revenue) + "\n              ")])]), _vm._v(" "), _c('h3', [_vm._v("\n              €\n              "), _c('span', [_vm._v("\n                " + _vm._s(_vm.result.historical_total_revenue) + "\n              ")])]), _vm._v(" "), (_vm.result.percentage_change_revenue >= 30) ? _c('b', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_revenue + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_revenue < 30 && _vm.result.percentage_change_revenue >= 0) ? _c('b', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_revenue + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_revenue < 0) ? _c('b', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_revenue + '%'))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" t.a.v vorige jaar in dezelfde periode ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "p-3 border bg-light"
  }, [_c('h5', [_vm._v("Orders")]), _vm._v(" "), _c('h3', [_c('span', [_vm._v("\n                " + _vm._s(_vm.result.order_amount) + "\n              ")])]), _vm._v(" "), _c('h3', [_c('span', [_vm._v("\n                " + _vm._s(_vm.result.historical_order_amount) + "\n              ")])]), _vm._v(" "), (_vm.result.percentage_change_order_amount >= 30) ? _c('b', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_amount + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_order_amount < 30 && _vm.result.percentage_change_order_amount >= 0) ? _c('b', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_amount + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_order_amount < 0) ? _c('b', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_amount + '%'))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" t.a.v vorige jaar in dezelfde periode ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "p-3 border bg-light"
  }, [_c('h5', [_vm._v("Gemiddelde orderwaarde")]), _vm._v(" "), _c('h3', [_c('span', [_vm._v("\n                " + _vm._s(_vm.result.average_order_value) + "\n              ")])]), _vm._v(" "), _c('h3', [_c('span', [_vm._v("\n                " + _vm._s(_vm.result.historical_average_order_value) + "\n              ")])]), _vm._v(" "), (_vm.result.percentage_change_order_value >= 30) ? _c('b', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_value + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_order_value < 30 && _vm.result.percentage_change_order_value >= 0) ? _c('b', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_value + '%'))]) : _vm._e(), _vm._v(" "), (_vm.result.percentage_change_order_value < 0) ? _c('b', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.result.percentage_change_order_value + '%'))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" t.a.v vorige jaar in dezelfde periode ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "p-3 mt-3"
  }, [_c('h5', [_vm._v("Labels")]), _vm._v(" "), _c('h5', [_vm._v("\n              Geselecteerde periode\n            ")]), _vm._v(" "), _c('h5', {
    staticClass: "mt-10"
  }, [_vm._v("\n              Geselecteerde periode (vorig jaar)\n            ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb933a16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/reports/RevenueReportPage.vue
// module id = 762
// module chunks = 1